import { render } from "./ListNews.vue?vue&type=template&id=bef37596&scoped=true"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"

import "./ListNews.vue?vue&type=style&index=0&id=bef37596&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef37596"]])

export default __exports__